import axios from 'axios'

import { POST_TYPE_BLOG_POST } from 'src/constants'
import { mapBlogPost } from 'src/data/mappers/mapBlogPost'
import { getCountryFromLocale } from 'src/functions/i18n/localeFns'
import { getWordpressUrl } from 'src/functions/url/getWordpressUrl'

import type { Locale } from 'src/enum/Locale'
import type { PostsResponse } from 'src/types/Post'

const excludedCategories = [1, 567, 961]

export const fetchBlogCategoryPosts = async (
  locale: Locale,
  categoryId?: number | null,
  page?: number,
): Promise<PostsResponse> => {
  const postsResponse = (await axios.get(getWordpressUrl(POST_TYPE_BLOG_POST), {
    params: {
      // excluded blog categories
      categories_exclude: excludedCategories.join(','),

      // language filter
      lang: getCountryFromLocale(locale),

      // embed context to limit default api fields
      context: 'embed',

      // amount of posts to display at once
      per_page: '9',

      // pagination
      ...(page && { page }),

      // blog category to fetch post listings for
      ...(categoryId && { categories: categoryId }),
    },
  })) as PostsResponse

  // strip modules as they are not needed for post listings and add A LOT of data on static export
  postsResponse.data.forEach((rawPost: any) => {
    rawPost.acf.modules_and_components = []
  })

  // map posts but skip populating SKUs, as they are not needed for post listings
  postsResponse.data = postsResponse.data.map((rawPost) => mapBlogPost(rawPost, locale))

  return postsResponse
}
